import { render } from "./AppRightMenu.vue?vue&type=template&id=31e8e163"
import script from "./AppRightMenu.vue?vue&type=script&lang=js"
export * from "./AppRightMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__